import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './Modal.module.css'; // سنقوم بإنشاء هذا الملف
import Icon from './Icon'; // نفترض وجود مكون Icon
import { FaTimes } from 'react-icons/fa';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  // منع تمرير الصفحة الخلفية عند فتح المودال
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    // تنظيف الـ effect عند إغلاق المكون
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  // استخدام Portal لعرض المودال في نهاية الـ body
  return createPortal(
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{title}</h2>
          <button onClick={onClose} className={styles.closeButton}>
            <Icon as={FaTimes} />
          </button>
        </div>
        <div className={styles.modalBody}>
          {children}
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')! // سنضيف هذا العنصر في index.html
  );
};

export default Modal;
